import permissions from './permission-list'

export default [
  {
    path: '/sale',
    name: 'sale',
    component: () => import('@/views/v2/Sale.vue'),
    meta: {
      pageTitle: 'Daftar Sale',
      resource: permissions.sale,
      action: 'read',
      breadcrumb: [
        {
          text: 'Daftar Sale',
          active: true,
        },
      ],
    },
  },
  {
    path: '/sale/create',
    name: 'sale-create',
    component: () => import('@/views/v2/SaleCreate.vue'),
    meta: {
      pageTitle: 'Buat Sale',
      resource: permissions.sale,
      action: 'manage',
      navActiveLink: 'sale',
      breadcrumb: [
        {
          text: 'Daftar Sale',
          active: false,
          to: { path: '/sale' },
        },
        {
          text: 'Buat',
          active: true,
        },
      ],
    },
  },
  {
    path: '/sale/:id',
    name: 'sale-detail',
    component: () => import('@/views/v2/SaleDetail.vue'),
    meta: {
      pageTitle: 'Detail Sale',
      resource: permissions.sale,
      action: 'read',
      navActiveLink: 'sale',
      breadcrumb: [
        {
          text: 'Daftar Sale',
          active: false,
          to: { path: '/sale' },
        },
        {
          text: 'Detail',
          active: true,
        },
      ],
    },
  },
  {
    path: '/sale/:id/edit',
    name: 'sale-edit',
    component: () => import('@/views/v2/SaleEdit.vue'),
    meta: {
      pageTitle: 'Edit Sale',
      resource: permissions.sale,
      action: 'manage',
      navActiveLink: 'sale',
      breadcrumb: [
        {
          text: 'Daftar Sale',
          active: false,
          to: { path: '/sale' },
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/sale/:id/brands',
    name: 'sale-brands',
    component: () => import('@/views/v2/SaleBrands.vue'),
    meta: {
      pageTitle: 'Kelola Brand Sale',
      resource: permissions.saleAllBrand,
      action: 'manage',
      navActiveLink: 'sale',
      breadcrumb: [
        {
          text: 'Daftar Sale',
          active: false,
          to: { path: '/sale' },
        },
        {
          text: 'Brand',
          active: true,
        },
      ],
    },
  },
  {
    path: '/sale/:id/brand/:brandSlug/price',
    name: 'sale-setup',
    component: () => import('@/views/v2/SaleSetup.vue'),
    meta: {
      pageTitle: 'Setup Harga Sale',
      resource: permissions.sale,
      action: 'manage',
      navActiveLink: 'sale',
      breadcrumb: [
        {
          text: 'Daftar Sale',
          active: false,
          to: { path: '/sale' },
        },
        {
          text: 'Setup Harga',
          active: true,
        },
      ],
    },
  },
]
